import { USER_PREFERENCE_KEY } from './constant';

export const getUserPreferenceFromLocalStorage = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_PREFERENCE_KEY) || '{}');
  } catch (error: any) {
    console.error('Error occured in getUserPreferenceFromLocalStorage ', error);
    return {};
  }
};

export const setUserPreferenceFromLocalStorage = (
  userPreference: Record<string, any>,
) => localStorage.setItem(USER_PREFERENCE_KEY, JSON.stringify(userPreference));

export const removeUserPreferenceFromLocalStorage = () =>
  localStorage.removeItem(USER_PREFERENCE_KEY);

export const getLoggedInUserDetailsFromLocalStorage = () => {
  try {
    return JSON.parse(localStorage.getItem('user-store') ?? '{}')?.state;
  } catch (error: any) {
    console.error(
      'Error occured in getLoggedInUserDetailsFromLocalStorage ',
      error,
    );
    return {};
  }
};
